export const IDLE_SESSION = {
  en_US: 'You have been logged out because of inactivity.',
  pt_BR: 'Você foi desconectado por inatividade.',
  es_ES: 'Se ha cerrado la sesión por inactividad.',
};
